import { Toaster as Sonner, toast } from "sonner"

// Toast coerenti con il tema Tech Gallery: superficie scura, bordo sottile, icona lime.
const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:rounded group-[.toaster]:border group-[.toaster]:border-line group-[.toaster]:bg-surface group-[.toaster]:text-chalk group-[.toaster]:shadow-soft group-[.toaster]:font-sans [&_[data-icon]]:text-lime",
          title: "group-[.toast]:text-sm group-[.toast]:font-medium",
          description: "group-[.toast]:text-steel group-[.toast]:text-xs",
          error: "[&_[data-icon]]:!text-[#F07C7C]",
          actionButton:
            "group-[.toast]:rounded-full group-[.toast]:bg-lime group-[.toast]:text-ink",
          cancelButton:
            "group-[.toast]:rounded-full group-[.toast]:bg-transparent group-[.toast]:border group-[.toast]:border-line group-[.toast]:text-steel",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
